export default "__VITE_ASSET__229bad63__"